import {
  FilterCriteriaItem,
  FilterObj,
  FilterOperatorEnum,
} from 'domains/appDomain';
import { isSingleOperator } from 'features/Platform/components/common/utils';
import { filter, isArray, isString, trim } from 'lodash-es';

export const normalizeValues = (
  value: string | number | boolean | (string | number | boolean)[]
) => {
  if (value === '' || value === null || value === undefined) {
    return undefined;
  }
  if (!isArray(value)) {
    return filter(
      [value],
      (val) => val !== null && val !== undefined && val !== ''
    );
  } else {
    return filter(
      value,
      (val) => val !== null && val !== undefined && val !== ''
    );
  }
};

export const normalizeFilterObj = (values: FilterObj) => {
  const entries = Object.entries(values);
  const newEntries: [string, FilterCriteriaItem][] = [];

  entries.forEach((entry: [string, FilterCriteriaItem]) => {
    if (
      entry[0] &&
      entry[1] &&
      (entry[1].operator === FilterOperatorEnum.EXISTS ||
        entry[1].operator === FilterOperatorEnum.NOT_EXISTS ||
        (entry[1]?.values && entry[1]?.values?.length > 0))
    ) {
      if (!entry[1].operator) {
        entry[1].operator = FilterOperatorEnum.EQUALS;
      }

      let values = entry[1].values;

      values = values
        .map((val) => {
          return isString(val) ? trim(val) : val;
        })
        .filter((val) => val !== null && val !== undefined);

      if (isSingleOperator(entry[1].operator) || values.length > 0) {
        entry[1].values = values;
        newEntries.push(entry);
      }
    }

    if (
      entry[0] === 'price' &&
      entry[1].values[0] !== undefined &&
      typeof entry[1].values[0] === 'number'
    ) {
      const values: number[] = [];
      values.push(entry[1].values[0]);

      entry[1].values = values;
      newEntries.push(entry);
    }
  });

  return Object.fromEntries(newEntries) as FilterObj;
};

export const normalizeToFormFields = (values: FilterObj) => {
  const entries = Object.entries(values);

  type FormFieldValueItem = {
    operator: FilterOperatorEnum;
    values: (string | number | boolean)[] | (string | number | boolean);
  };

  const newEntries: [string, FormFieldValueItem][] = [];

  entries.forEach((entry: [string, FilterCriteriaItem]) => {
    if (
      isArray(entry[1]?.values) &&
      entry?.[1]?.values.length === 1 &&
      entry?.[1]?.values[0] === ''
    ) {
      newEntries.push([
        entry[0],
        {
          operator: entry[1]?.operator,
          values: entry[1]?.values[0],
        },
      ]);
    } else {
      newEntries.push(entry);
    }
  });

  return Object.fromEntries(newEntries) as FilterObj;
};

export const organizeStructure = (str: string) => {
  return {
    width: +(str || '').split('x')[0] ? +(str || '').split('x')[0] : 0,
    length: +(str || '').split('x')[1] ? +(str || '').split('x')[1] : 0,
  };
};

export const cubeOrganizeStructure = (str: string) => {
  return {
    width: +(str || '').split('x')[0] ? +(str || '').split('x')[0] : 0,
    length: +(str || '').split('x')[1] ? +(str || '').split('x')[1] : 0,
    height: +(str || '').split('x')[2] ? +(str || '').split('x')[2] : 0,
  };
};
